export const BoardListSkeleton = () => (
  <div className="mt-1.5 flex w-full animate-pulse flex-col gap-2.5 px-2.5">
    <div className="h-[34px] w-[177px] max-w-full rounded-lg bg-white/10" />
    <div className="h-[34px] w-[130px] max-w-full rounded-lg bg-white/10" />
    <div className="h-[34px] w-[70px] max-w-full rounded-lg bg-white/10" />
  </div>
);
